import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { IntegrityMonitorPauseSchema } from '../type';

export class IntegrityMonitorPauseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IntegrityMonitorPauseSchema> {
    throw new Error('Not implemented');
  }
}
